import React from 'react'
import PropTypes from 'prop-types'

class WizardStep extends React.Component {
  constructor() {
    super()

    this.renderChildren = this.renderChildren.bind(this)
  }

  renderChildren() {
    const { children, onNext, onPrevious } = this.props

    return React.Children.map(children, (child) => {
      const props = Object.assign({}, child.props, {
        onNext,
        onPrevious,
      })
      return React.cloneElement(child, props)
    })
  }

  render() {
    const { active, customClass } = this.props
    const className = `wizardStep ${active ? 'active' : 'inactive'} ${customClass}`

    return (
      <div className={className}>
        { this.renderChildren() }
      </div>
    )
  }
}

WizardStep.defaultProps = {
  active: false,
  isWizardStep: true,
  onNext: undefined,
  onPrevious: undefined,
  render: true,
  customClass: '',
}

WizardStep.propTypes = {
  active: PropTypes.bool,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  render: PropTypes.bool,
}

export default WizardStep
